"use client";

import React, { ReactNode } from "react";

import { usePathname } from "next/navigation";

import { AtcAreaProvider } from "./AtcAreaProvider";

interface AtcAreaConditionalLayoutProviderProps {
  children: ReactNode;
}

export function AtcAreaConditionalLayoutProvider({
  children,
}: AtcAreaConditionalLayoutProviderProps) {
  const pathname = usePathname();

  /*
   * Check if the current path is NOT the special "pdp-with-two-atc" page,
   * to determine if a global context should be active.
   */
  const isGlobalProviderActive = !["/pdp-with-two-atc/"].includes(pathname);

  if (isGlobalProviderActive) {
    /*
     * If a global provider is needed, render the stateful AtcAreaProvider
     * This provider will supply a valid, non-null context object
     */
    return <AtcAreaProvider>{children}</AtcAreaProvider>;
  }

  // If no global context is needed, just render the children
  return <>{children}</>;
}
